var exports = {
  "q": "DiscoveryGuildHeader.module__headerTitle___V3Qwb1",
};

module.exports = exports;
